<template>
  <div class="confirm-layout">
    <div class="alert alert-success">
      此藥物總存量: {{ selectedDrugTotalAmount }} 
    </div>

    <Action 
      v-if="currentProgress === 'confirmAmount'"
      v-on:confirmAmountFinish="confirmAmountFinish"
      :defaultNum="currentDrugInDevice.stock"
      :autoCaculateAmount="false"
      :compType="'Confirm'"
      :valueMoreThanZero="false"
      :defaultPackCount="currentDrugInDevice.pack_count"
      :deviceId="currentDrugInDevice.device.id"
      :checkNum="currentDrugInDevice.max_stock" >
      <h5>確認藥盒內數量</h5>
    </Action>


    <Action
      v-if="currentProgress === 'action'"
      :defaultNum="currentDrugInDevice.stock"
      :deviceId="currentDrugInDevice.device.id"
      :defaultPackCount="currentDrugInDevice.pack_count"
      :inputReadOnly="true"
      :valueMoreThanZero="false"
      v-on:setActionData="getActionData">
      <h5>移除藥物數量</h5>
    </Action>

    <Loader v-if="currentProgress === 'finish'"/>
    <NumberSet 
      v-if="currentProgress === 'setMinStock'"
      v-on:setNum="getMinStorage"
      :defaultAmount="minStorage"
      :canBeZero="true"
      :inputLabel="'更新安全存量'"
    />
  </div>
</template>


<script>
import moment from 'moment';
import ConfirmFlowBase from '../ComponentBase/ConfirmFlowBase';
import Action from '../flowComp/Action';
import Loader from '../common/Loader';
import NumberSet from '../flowComp/NumberSet';

export default {
  name: 'ConfirmFlow',
  extends: ConfirmFlowBase,
  props: [],
  data() {
    return {
      confirmAmount: 0,
      storageAmount: 0,
      totalStorageInSystemId: null,
      minStorage: null,
      emitTimes: 0,
      confirmPackCount: 0,
    };
  },
  components: {
    Action,
    Loader,
    NumberSet,
  },
  beforeUpdate() {
    if (this.currentProgress === 'action') {
      this.confirmAmount = this.currentDrugInDevice.stock;
      this.confirmPackCount = this.currentDrugInDevice.pack_count;
    }
  },
  methods: {
    getActionData() {
      this.emitTimes += 1;
      // prevent over emitting.
      if (this.emitTimes === 1) {
        this.emitData();
      }
    },
    getMinStorage(val) {
      this.instance.patch(`/api/total-storage-in-system/${this.totalStorageInSystemId}/`, {
        min_stock: val,
      })
      .then((res) => {
        this.$emit('confirmationFinish');
        this.resetProgress();
        this.emitTimes = 0; // reset
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: `安全存量不可大於總最大庫存量: ${err.response.data.max_stock}`,
          keepOnTop: true,
        });
      });
    },
    async emitData() {
      const medId = this.currentDrugInDevice.medication.id;
      this.nextProgress(); // let the loader showup
      await this.instance.delete(`/api/drug-storage/${this.currentDrugInDevice.id}/`)
      .then(() => {
        // check whether other durg storage with same medication exists.
        this.instance.get('/api/drug-storage/', {
          params: {
            medication: medId,
            exclude_return_device: true,
            device__net__system: this.$store.state.device.systemId,
          },
        })
        .then(async (res) => {
          await this.$store.dispatch('getTotalDrugAmountInstanly', medId);
          const filteredList = [];
          res.data.results.forEach((item) => {
            const theExpiredDate = moment(item.expired_date);
            const todayDate = moment();
            const remainExpiredDays = theExpiredDate.diff(todayDate, 'days');
            if (remainExpiredDays >= 0) {
              filteredList.push(item);
            }
          });
          if (filteredList.length > 0) {
            this.nextProgress(); // set for the min_stock
            this.instance.get(`/api/total-storage-in-system/?medication=${medId}`)
            .then((res) => {
              this.totalStorageInSystemId = res.data.results[0].id;
              this.minStorage = parseInt(res.data.results[0].min_stock, 10);
              console.log(this.minStorage);
            });
          } else {
            this.$emit('confirmationFinish');
            this.resetProgress();
            this.emitTimes = 0; // reset
          }
        });
      });
    },
    async confirmAmountFinish(payload) {
      await this.$store.dispatch('updateCurrentDrugInDevice', this.currentDrugInDevice.id);
      this.confirmAmount = payload.totalSum;
      this.confirmPackCount = payload.packCount;
      this.nextProgress();
      setTimeout(() => {
        this.nextProgress();
      }, 200);
    },
  },
  created() {
    if (this.currentProgress === 'wait') this.nextProgress();
  },
  computed: {
  },
};
</script>



// WEBPACK FOOTER //
// ConfirmFlow.vue?3af190ba